import firebase from './firebase';

var db = firebase.firestore();


export default {
    get(cb) {
        db.collection('users').onSnapshot((snap) => {
            var users = [];
            snap.forEach((doc) => {
                var data = doc.data();
                data.id = doc.id;
                users.push(data);
            });
            cb(users);
        });
    },
    changeRole(user) {
        
        db.collection('users').doc(user.id).update({
            role: user.role
        }).then(function() {
            console.log("Document successfully updated!");
        })
        .catch(function(error) {
            // The document probably doesn't exist.
            console.error("Error updating document: ", error);
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/UserService.js